import type { EnquiryDto } from "@/dto/EnquiryDto";
import ApiClient from "@/api/infrastructure/ApiClient";

export default {
  async send(dto: EnquiryDto): Promise<void> {
    await ApiClient.post("/enquiry", dto);
  },
};
